import React, { useEffect } from "react";

const BootstrapModal = ({
  show,
  title,
  children,
  footer = null,
  onClose,
  staticBackdrop = true,
  keyboard = false,
  dialogClassName = "",
}) => {
  useEffect(() => {
    if (!show) return;

    const onKeyDown = (e) => {
      if (!keyboard) return;
      if (e.key === "Escape") onClose?.();
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [show, keyboard, onClose]);

  if (!show) return null;

  const onBackdropClick = () => {
    if (!staticBackdrop) onClose?.();
  };

  return (
    <>
      <div
        className='modal fade show'
        style={{ display: "block" }}
        tabIndex={-1}
        role='dialog'
        aria-modal='true'
      >
        <div className={`modal-dialog ${dialogClassName}`} role='document'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h1 className='modal-title fs-5'>{title}</h1>
              {onClose && (
                <button
                  type='button'
                  className='btn-close'
                  aria-label='Close'
                  onClick={onClose}
                />
              )}
            </div>

            <div className='modal-body'>{children}</div>

            {footer ? <div className='modal-footer'>{footer}</div> : null}
          </div>
        </div>
      </div>

      <div className='modal-backdrop fade show' onClick={onBackdropClick} />
    </>
  );
};

export default BootstrapModal;
